import queryClient from '../../../ReactQuery/client';
import useMutation from '../../../ReactQuery/useMutation';
import { post } from '../../../redux/api';
import type { LicensingPolicy } from '../../../../typings/api';
import type { LicensingRule, PolicyId } from '../../../types';

type BulkCreateRequest = { newRules: Array<Partial<LicensingRule>>; };

type CreatePolicyRulesParams = {
  policyId: PolicyId;
  newRules: BulkCreateRequest;
};

const postPolicyRules = ({ policyId, newRules }: CreatePolicyRulesParams) => {
  return post<BulkCreateRequest, LicensingPolicy | undefined>(`/api/policies/${policyId}/rules/bulk`, newRules);
};

/**
 * hook for creating many new licensing policy rules
 */
export default function useCreatePolicyRules() {
  return useMutation<CreatePolicyRulesParams, {data?: LicensingPolicy}>({
    mutationFn: (params) => postPolicyRules(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['policy'] });
    },
  });
}
